import { PledgeTransactionTypeEnum } from '@tassat/common-definitions';
import { CollateralHistoryDetailRecord } from '@tassat/fred-definitions';
import { createContext } from 'react';

import type { PledgeContextWorkflowAction } from './pledgeContextWorkflowReducer';
import type { ModalScreen } from '../pledgeDetailsModal';

export type PledgeTransactionRow = CollateralHistoryDetailRecord['PledgeTransaction'][number];

export type PledgeModalAction = 'approve' | 'decline' | 'cancel';

export interface ModalPledgeValues {
    // Create pledge flow
    Type?: string;
    AssetType?: {
        value: string;
        label: string;
        refData?: { security?: any; currency?: any };
    };
    AssetAmount?: string | null;
    FiatAmount?: string | null;
    Recipient?: {
        label: string;
        value: { NickName?: string; AccountName?: string };
    } | null;
    RecipientAddress?: string;
    // Approval flow
    RequestId?: string;
    DeclineReason?: string;
    Ticker?: string;
    AssetQuantity?: number | string;
    ReceivingAccountName?: string;
    PledgeId?: string;
    // AddOn / Release / Reclaim flow
    PledgeParticipant?: CollateralHistoryDetailRecord['PledgeParticipant'];
}

export interface PledgeContextWorkflowContextState {
    pledgeContextWorkflowState: PledgeContextWorkflowState;
    dispatchPledgeContextWorkflowAction: React.Dispatch<PledgeContextWorkflowAction>;
}

export interface PledgeContextWorkflowState {
    modalScreen: ModalScreen;
    pledgeActionInProgress: boolean;
    accountId: string;
    pledgeType: PledgeTransactionTypeEnum | null;
    modalPledgeValues: ModalPledgeValues | null;
    selectedPledgeTransaction: PledgeTransactionRow | null;
    selectedPledge: any;
    modalAction: PledgeModalAction | null;
}

export const DEFAULT_INITIAL_STATE: PledgeContextWorkflowState = {
    modalScreen: 'details',
    pledgeActionInProgress: false,
    accountId: '',
    pledgeType: null,
    modalPledgeValues: null,
    selectedPledgeTransaction: null,
    selectedPledge: null,
    modalAction: null
};

const PledgeContextWorkflowContext = createContext<PledgeContextWorkflowContextState | null>(null);

export default PledgeContextWorkflowContext;